import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "grid font-bold" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, "#"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, "no."),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, "ORDER NUMBER"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "NOTE"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-right" }, "PRICE"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 text-right" }, "PRICE + VAT")
], -1)
const _hoisted_6 = { class: "col-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = { class: "col-1 text-right" }
const _hoisted_12 = { class: "col-2 text-right" }

import {computed, inject, onMounted, reactive, ref} from 'vue'
import {Company, InvoiceItem} from "@/components/blocks/Types";
import Card from "primevue/card";
import Panel from "primevue/panel";
import Button from "primevue/button";
import ConfirmDialog from "primevue/confirmdialog";
import {minValue, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import InputField from "@/components/blocks/InputField.vue";
import InputFieldNum from "@/components/blocks/InputFieldNum.vue";
import {AxiosStatic} from "axios";
import {useConfirm} from "primevue/useconfirm";

// Define emits
interface Properties {
  items: InvoiceItem[]
  invoiceId: number,
  invoiceNumber: string,
  issuer: Company
}

type FormData = {
  note: string | null,
  amount: number
  vatRate: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceItems',
  props: {
    items: null,
    invoiceId: null,
    invoiceNumber: null,
    issuer: null
  },
  emits: ['itemCreated'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  items: InvoiceItem[]
  invoiceId: number,
  invoiceNumber: string,
  issuer: Company
};



// Define type
const rules = {
  note: {required},
  amount: {required, minValue: minValue(1)},
  vatRate: {required, minValue: minValue(0)}
}

// Define component properties


// Define component values
const invoiceItem = ref()
const axios = inject<AxiosStatic>('axios')

const formData = reactive<FormData>({
  note: null,
  amount: 0,
  vatRate: getVatRate()
})

const formRef = ref(null)
const submitted = ref<boolean>(false)
const v$ = useVuelidate(rules, formData)
const confirm = useConfirm()

// Define lifecycle hooks
onMounted(() => {
  if (props.items != null && props.items.length > 0) {
    invoiceItem.value = props.items
  }
})

// Define functions
function deleteItem(item: InvoiceItem, index: number) {

  confirm.require({
    message: 'Do you want delete item ' + (item?.requisition?.note || item.note),
    header: 'Delete item no. ' + (index + 1),
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      callRemoteDelete(item)
    }
  })
}

function callRemoteDelete(item: InvoiceItem) {

  axios?.delete(`/invoice/detail/${props.invoiceNumber}/delete-item/${item.id}`)
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          emits('itemCreated', response.data)
        } else {
          console.error('Can not delete item from invoice!')
        }
      })
}

function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    saveItem()
  } else {
    console.error('Form is not valid!')
  }
}

function saveItem() {
  axios?.post("/invoice/detail/" + props.invoiceId + '/add-item', buildData()).then((response: any) => {
    if (response.status >= 200 && response.status <= 299) {
      emits('itemCreated', response.data)
      clearForm()
    } else {
      // message.error('Ulozeni spolecnosti se nezdarilo!')
      console.error(response)
    }
  })
}

function clearForm() {
  formData.note = null
  formData.amount = 0
  formData.vatRate = getVatRate()
  submitted.value = false
}

function getVatRate(): number {
  if (props.issuer.platceDph == true) {
    return 21
  } else {
    return 0
  }
}


function buildData(): any {
  if (props.issuer.platceDph === true) {
    const pvv: number = ((formData.vatRate / 100.0) + 1.0) * formData.amount
    return {
      description: formData.note,
      price: formData.amount,
      vatRate: formData.vatRate,
      vatAmount: pvv - formData.amount,
      priceWithVat: pvv,
    }
  } else {
    return {
      description: formData.note,
      price: formData.amount,
      vatRate: 0,
      vatAmount: 0,
      priceWithVat: formData.amount,
    }
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ConfirmDialog)),
    _createVNode(_unref(Panel), {
      header: "Add invoice item",
      class: "mt-2",
      collapsed: __props.items.length>0,
      toggleable: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
          class: "p-fluid"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(InputField, {
                id: "note",
                class: "field col-4",
                label: "Note",
                vualidate: _unref(v$).note,
                submitted: submitted.value,
                modelValue: _unref(v$).note.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).note.$model) = $event))
              }, null, 8, ["vualidate", "submitted", "modelValue"]),
              _createVNode(InputFieldNum, {
                id: "amount",
                class: "field col-1",
                label: "amount",
                vualidate: _unref(v$).amount,
                submitted: submitted.value,
                modelValue: _unref(v$).amount.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).amount.$model) = $event))
              }, null, 8, ["vualidate", "submitted", "modelValue"]),
              _createVNode(InputFieldNum, {
                id: "vatrate",
                suffix: "%",
                class: "field col-1",
                label: "Vat rate",
                vualidate: _unref(v$).vatRate,
                submitted: submitted.value,
                modelValue: _unref(v$).vatRate.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).vatRate.$model) = $event))
              }, null, 8, ["vualidate", "submitted", "modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(Button), {
                  type: "submit",
                  label: "Pridat"
                })
              ])
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["collapsed"]),
    (__props.items && __props.items.length>0)
      ? (_openBlock(), _createBlock(_unref(Card), {
          key: 0,
          class: "mt-2"
        }, {
          content: _withCtx(() => [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i.id,
                class: "grid border-top-1"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["i-button pi text-red-900 cursor-pointer", props.icon || 'pi-trash']),
                    onClick: ($event: any) => (deleteItem(i, index))
                  }, null, 10, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(index + 1), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(i.requisition?.customerNumber || 'n/a'), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(i.requisition?.note || i.note), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(i.price.toFixed(2)), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(i.totalPrice.toFixed(2)), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})